<template>
  <div class="builder-steps" data-test-id="builder-steps">
    <BuilderStep
      v-for="(step, index) in steps"
      :key="step.key ?? index"
      :icon="step.icon"
      :label="step.label"
      :active="currentStepKey === step.key"
      :completed="isStepCompleted(step, index)"
      :substeps="step.substeps || []"
      :current-substep-key="currentStepKey === step.key ? currentSubstepKey : null"
      :current-substep-index="currentStepKey === step.key ? currentSubstepIndex : -1"
      :clickable="isStepClickable(step, index)"
      :highestSubstepReached="index === highestStepReached ? highestSubstepReached : -1"
      :compact="compact"
      :free-navigation="freeNavigation"
      :parent-clickable-with-substeps="!!step.parentClickableWithSubsteps"
      :error="!!step.error"
      :loading="loading"
      @click-step="$emit('navigate', { stepIndex: index, substepIndex: 0, source: 'step' })"
      @click-substep="
        $emit('navigate', { stepIndex: index, substepIndex: $event, source: 'substep' })
      "
    />
  </div>
</template>

<script>
import BuilderStep from "./BuilderStep.vue";

export default {
  name: "BuilderSteps",
  components: {
    BuilderStep,
  },
  props: {
    steps: {
      type: Array,
      required: true,
      default: () => [],
    },
    currentStepIndex: {
      type: Number,
      default: 0,
    },
    currentSubstepIndex: {
      type: Number,
      default: 0,
    },
    currentStepKey: {
      type: String,
      default: null,
    },
    currentSubstepKey: {
      type: String,
      default: null,
    },
    highestStepReached: {
      type: Number,
      default: 0,
    },
    highestSubstepReached: {
      type: Number,
      default: 0,
    },
    compact: {
      type: Boolean,
      default: true,
    },
    freeNavigation: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["navigate"],
  methods: {
    isStepClickable(step, index) {
      if (this.loading) return false;
      if (this.freeNavigation) return !!step.completed || index <= this.currentStepIndex;
      return index <= this.highestStepReached;
    },
    isStepCompleted(step, index) {
      if (this.freeNavigation) return !!step.completed;
      return this.currentStepIndex > index;
    },
  },
};
</script>

<style scoped>
.builder-steps {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
